// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Reports_wrapper__1YO1y","table":"Reports_table__3ajob"};